<script>
import BaseConfig from './_base-config.vue';

export default {
  name: 'AudioConferencingAdd2Cart',
  extends: BaseConfig,
};
</script>
